import React from 'react';
import { useTranslation } from 'react-i18next/';

import logo from 'src/assets/images/logo.png';
import Form from 'src/components/Form/Form';
import './RetailPasswordChange.scss';

function RetailPasswordChange() {
  const { t } = useTranslation();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get('token');

  const steps = [
    {
      inputs: [
        {
          type: 'password',
          className: 'hidden',
          label: `${ t('form.token') }:`,
          name: 'token',
          disabled: true,
          hidden: false,
          horizontal: true,
          value: token
        },
        {
          type: 'password',
          className: 'full-width',
          label: `${ t('form.currentPasswordLabel') }:`,
          name: 'current',
          value: '',
          disabled: false,
          required: true,
          hidden: false,
          horizontal: true
        },
        {
          type: 'password',
          className: 'full-width',
          label: `${ t('form.newPasswordLabel') }:`,
          name: 'password',
          required: true,
          hideIcon: true,
          hidden: false,
          horizontal: true
        },
        {
          type: 'password',
          className: 'full-width',
          label: `${ t('form.confirmPasswordLabel') }:`,
          name: 'confirmation',
          required: true,
          hideIcon: true,
          hidden: false,
          horizontal: true
        }
      ],
      buttons: [
        {
          type: 'submit',
          label: t('form.changePassword')
        }
      ]
    }
  ];

  return (
    <div className="login-container">
      <div className="password-change">
        <div className="password-change__logo">
          <img src={ logo } alt="Logo" />
        </div>

        <div className="password-change__form-container">
          <Form
            containerClass={ localStorage.getItem('retail') ? 'changePassword-form' : 'tradingLogin-form' }
            steps={ steps }
          />
        </div>
        {
          localStorage.getItem('retail') &&
      <>
        <div className="password-change__environment">
          { window.location.hostname }
        </div>
      </>
        }
      </div>
    </div>
  );
}

export default RetailPasswordChange;
